import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './redux/actions';

export class WelcomePopup extends Component {
  static propTypes = {
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  closeCard = () => {
    const { projectId, version } = this.props;
    this.props.actions.hideProjectWelcomePopup({
      projectId,
      version,
      data: { isShowWelcomePopup: false },
    });
  };

  render() {
    const { home } = this.props;
    const { projectDetail, showProjectWelcomePopup } = home || '';
    const { isShowWelcomePopup } = projectDetail ? projectDetail : true;

    if (isShowWelcomePopup && showProjectWelcomePopup) {
      return (
        <div className="gjs-mdl-container">
          <div
            className="gjs-mdl-dialog gjs-one-bg gjs-two-color"
            style={{ maxWidth: '80%', marginLeft: '7em' }}
          >
            <div className="gjs-mdl-header">
              <div className="gjs-mdl-title" style={{ textAlign: 'center' }}>
                Welcome to{' '}
                {process.env.REACT_APP_ENVIRONMENT === 'PRODUCTION' ? 'DrapCode' : 'Webconnect'}{' '}
                Builder!
              </div>
              <div className="gjs-mdl-btn-close" onClick={this.closeCard}>
                ⨯
              </div>
            </div>
            <div className="gjs-mdl-content">
              <div id="gjs-mdl-c">
                <iframe
                  width="100%"
                  height="560vh"
                  src="https://www.youtube.com/embed/KXqrIYnCRSY"
                  frameBorder="0"
                  allowFullScreen
                ></iframe>
              </div>
              <div className="pt-2">
                This is a quick video to help you understand the basics of the{' '}
                {process.env.REACT_APP_ENVIRONMENT === 'PRODUCTION' ? 'DrapCode' : 'Webconnect'}{' '}
                Builder.
              </div>
            </div>
          </div>
        </div>
      );
    } else return '';
  }
}

function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(WelcomePopup);
